import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

// Define props
interface Props {
  isCriteriaFloconVert: boolean;
  isCriteriaCleVerte: boolean;
}
interface EcoAction {
  icon: string;
  text: string;
  key: string;
}

// Define all possible actions with their corresponding icons and text

export default /*#__PURE__*/_defineComponent({
  __name: 'EcoActions',
  props: {
    isCriteriaFloconVert: { type: Boolean },
    isCriteriaCleVerte: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  isCriteriaFloconVert: boolean;
  isCriteriaCleVerte: boolean;
};



// Access the global content object
const content = window.content as { [key: string]: string };

// Compute the eco actions title based on the criteria
const ecoActionsTitle = computed<string>(() => {
  if (props.isCriteriaFloconVert && props.isCriteriaCleVerte) {
    return content.eco_responsible_commitments_actions_title_if_both_labels;
  } else if (props.isCriteriaCleVerte) {
    return content.eco_responsible_commitments_actions_title_if_cleverte_label;
  } else if (props.isCriteriaFloconVert) {
    return content.eco_responsible_commitments_actions_title_if_floconvert_label;
  }
  return '';
});

// Define interface for actions
const allActions = computed<EcoAction[]>(() => [
  {
    icon: '#___icon___responsible',
    text: content.eco_responsible_commitments_save_water_action,
    key: 'save_water',
  },
  {
    icon: '#___icon___localisation',
    text: content.eco_responsible_commitments_sustainable_activities_action,
    key: 'sustainable_activities',
  },
  {
    icon: '#___icon___temperature',
    text: content.eco_responsible_commitments_foot_print_action,
    key: 'foot_print',
  },
  {
    icon: '#___icon___spray',
    text: content.eco_responsible_commitments_responsible_cleaning_action,
    key: 'responsible_cleaning',
  },
  {
    icon: '#___icon___recycle',
    text: content.eco_responsible_commitments_waste_reduction_action,
    key: 'waste_reduction',
  },
  {
    icon: '#___icon___electricity',
    text: content.eco_responsible_commitments_low_electiricity_consumption_action,
    key: 'low_electricity_consumption',
  },
]);

// Compute the filtered actions based on the criteria
const filteredActions = computed<EcoAction[]>(() => {
  if (props.isCriteriaFloconVert && !props.isCriteriaCleVerte) {
    return allActions.value.filter(action =>
      !['responsible_cleaning', 'low_electricity_consumption'].includes(action.key)
    );
  }
  return allActions.value;
});

return { __sfc: true,props, content, ecoActionsTitle, allActions, filteredActions }
}

})